import { createAction, props } from '@ngrx/store';
import { FenceResultPost } from '@app/rest-client/faxe/models/fence-result-post';
import { FenceResult } from '@app/rest-client/faxe/models/fence-result';
import { SliceState } from '@app/store/faxe/sapiens-entity-state';

const prefix = '[FAXE-FENCE-RESULT]';

export const fetchAllFenceResult = createAction(
  `${prefix} - fetch all`,
  props<{ raceGuid: string, requiredSliceState: SliceState; issuerStack: string[] }>()
);

export const getFenceResult = createAction(
  `${prefix} - get`,
  props<{ raceGuid: string, requiredSliceState: SliceState; issuerStack: string[] }>()
);

export const addManyFenceResult = createAction(
  `${prefix} - add many`,
  props<{ models: FenceResult[]; sliceState: SliceState; issuerStack: string[] }>()
);

export const patchManyFenceResult = createAction(
  `${prefix} - patch many`,
  props<{ models: FenceResult[]; issuerStack: string[] }>()
);

export const postFenceResult = createAction(
  `${prefix} - post`,
  props<{ fenceResult: FenceResultPost[]; raceGuid: string, userGuid: string, signature: string, issuerStack: string[]; correlationId: string }>()
);

export const purgeFenceResult = createAction(
  `${prefix} - purge`,
  props<{ issuerStack: string[]; correlationId: string }>()
);


